import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class Template extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            pic: '',
            picFileName: ''
        };
    }
    setProfilePic(_file) {
        this.getBase64(_file).then(file => {
            this.state.pic = file;
            this.state.picFileName = _file.name;
        });
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/template/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/template/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            fields: this.state.data.record.fields,
            websiteId: this.state.data.record.websiteId,
            type: this.state.data.record.type,
            pic: this.state.pic,
            picFileName: this.state.picFileName,
            users: this.state.data.users,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.state.caller.refreshData();
                this.closeMe();
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    getLuxFields() {
        return [
            { name: 'model', label: 'مدل کالا' },
            { name: 'stuffWeight', label: 'وزن کالا' },
            { name: 'typeId', label: 'نوع سنگ' },
            { name: 'selectedTypes', label: 'نوع سنگ مخراجی' },
            { name: 'kindId', label: 'نوع تراش' },
            { name: 'weightId', label: 'نوع وزن' },
            { name: 'sizeId', label: 'سایز' },
            { name: 'vazn', label: 'وزن تقریبی' },
            { name: 'vazn2', label: 'وزن سنگ مخراجی' },
            { name: 'tol', label: 'طول' },
            { name: 'arz', label: 'عرض' },
            { name: 'height', label: 'ارتفاع' },
            { name: 'ostad', label: 'قلم استاد' },
            { name: 'ostadArtName', label: 'هنر دست استاد' },
            { name: 'hakak', label: 'نام حکاک' },
            { name: 'matnhakak', label: 'متن حکاکی' },
            { name: 'ringId', label: 'سایز رینگ' },
            { name: 'note', label: 'توضیحات' },
            { name: 'pic', label: 'تصویر' },
        ]
    }
    getStoneFields() {
        return [
            { name: 'kindId', label: 'نوع تراش' },
            { name: 'weightId', label: 'نوع وزن' },
            { name: 'sizeId', label: 'ابعاد واحد' },
            { name: 'vazn', label: 'وزن' },
            { name: 'tol', label: 'طول' },
            { name: 'arz', label: 'عرض' },
            { name: 'height', label: 'ارتفاع' },
            { name: 'rank', label: 'رتبه بندی' },
            { name: 'difficulty', label: 'درجه سختی' },
            { name: 'ri', label: 'ضریب شکست' },
            { name: 'sg', label: 'وزن مخصوص' },
            { name: 'characteristics', label: 'پاکی سنگ' },
            { name: 'note', label: 'توضیحات' },
            { name: 'pic', label: 'تصویر' },
        ]
    }
    getFields() {
        if (this.state.data.record.type === 1) return this.getStoneFields();
        if (this.state.data.record.type === 2) return this.getLuxFields();
        return [];
    }
    setType(e) {
        this.state.data.record.fields = '';
        this.state.data.record.type = e;
        this.setState({ data: this.state.data });
    }
    setFields(e,v) {
        this.state.data.record.fields = this.state.data.record.fields.replace('[' + v + ']', '');
        if (e.target.checked)
            this.state.data.record.fields += '[' + v + ']';
    }
    checked(v) {
        return this.state.data.record.fields.includes('[' + v + ']');
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{"width": "90%"}}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات الگو" : "افزودن الگوی جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">عنوان</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">وبسایت</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control" type="text" defaultValue={this.state.data.record.websiteId} onChange={e => this.state.data.record.websiteId = e.target.value}>
                                                    <option value={this.getDefaultGuid()}>انتخاب کنید ...</option>
                                                    {this.state.data.websites.map(website =>
                                                        <option value={website.id}>{website.title}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">فایل گزارش</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.data.record.id === this.defaultGuid() && <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">نوع الگو</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control" type="text" defaultValue={this.state.data.record.type} onChange={e => this.setType(parseInt(e.target.value))}>
                                                    <option value="0">انتخاب کنید ...</option>
                                                    <option value="1">شناسنامه سنگ</option>
                                                    <option value="2">شناسنامه فاخر</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className="col-lg-12 mt-4 mb-2"><p>فیلدهای انتخابی</p></div>
                                    {this.getFields().map(field => <div className="col-lg-2">
                                        <div className="form-group">
                                            <input defaultChecked={this.checked(field.name)} onChange={e => this.setFields(e, field.name)} type="checkbox" /> <label className="form-label">{field.label}</label>
                                        </div>
                                    </div>)}
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">کاربران</label>
                                            <SelectAsync
                                                defaultValue={this.state.data.users}
                                                isMulti={true}
                                                placeholder="انتخاب کاربران"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadUsersOptions(inputValue, callback, 0)}
                                                onChange={e => this.state.data.users = e}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}